export default "__VITE_ASSET__ms3DnyHi__"